import React, { useEffect, useState } from 'react';
import { faCircleXmark, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
const CustomListModal = (props) => { // props: {customListButtonSave}
    const [visible, setVisible] = useState(false);
    const [newListNameValue, setNewListNameValue] = useState('');
    const { t, i18n } = useTranslation();

    const handleClose = () => {
        setVisible(false);
        props.customListButtonSave(newListNameValue);
    }

    const handleShow = () => setVisible(true);
    return (
        <div className="custom-list-modal">

            <div className="add-button" onClick={handleShow} >
                <FontAwesomeIcon className='icon text-align-right float-right cursor-pointer' icon={faPlus} />
            </div>

            <Modal show={visible} onHide={handleClose}
                className='customListModal'
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header className='watchlistAddModalHeader'>
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                    <Container className='container'>
                        <Row className='columnsSelectHeaderRow cursor-pointer'>
                            <Col md="11" className='color-text roboto-bold-18 '>{t('createNewList')}</Col>
                            <Col md="1"><FontAwesomeIcon className='modalCloseIcon text-align-right float-right cursor-pointer' icon={faCircleXmark} onClick={handleClose} /></Col>
                        </Row>
                    </Container>
                </Modal.Header>

                <Modal.Body className='watchlistAddModalBody'>


                    <Container className='modalBodyContainer'>


                        <Row className='m-t-5'>
                            <Col className=' roboto-medium-16 m-auto'>
                                <InputText className='newListCreateInput' placeholder={t('listName')} value={newListNameValue} onChange={(e) => setNewListNameValue(e.target.value)} />
                            </Col>


                        </Row>
                    </Container>

                </Modal.Body>
                <Modal.Footer className='watchlistAddModalFooter'>

                    <Container>
                        <Row>
                            <Col md='12'>
                                <Button className='save-button roboto-bold-17' variant="primary" onClick={handleClose}>
                                {t('save')}
                                </Button>
                            </Col>
                        </Row>
                    </Container>

                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default CustomListModal;

